(() => {
 if (window.banditosInlineCart) return;
 window.banditosInlineCart = true;
 let popup, home, trigger, wasOpen = false;
 const relabel = () => {
  if (!popup?.classList.contains('banditos-inline-options')) return;
  const setLabel = (el, text) => {
   if (!el || el.textContent.trim() === text) return;
   if (!el.hasAttribute('data-inline-original-label')) el.setAttribute('data-inline-original-label',el.textContent);
   el.textContent = text;
  };
  setLabel(popup.querySelector('.halo-popup-title'),'EDIT / ADD OPTIONS');
  popup.querySelectorAll('[data-edit-cart-add-more]').forEach(el => setLabel(el.querySelector('.text') || el,'ADD ANOTHER SIZE'));
  const save = popup.querySelector('#add-all-to-cart');
  setLabel(save?.querySelector('.text') || save,'SAVE CHANGES');
 };
 const contentObserver = new MutationObserver(relabel);
 const restore = () => {
  if (!popup) return;
  if (home?.isConnected) home.after(popup); else document.body.append(popup);
  contentObserver.disconnect();
  popup.querySelectorAll('[data-inline-original-label]').forEach(el => {
   el.textContent = el.getAttribute('data-inline-original-label');
   el.removeAttribute('data-inline-original-label');
  });
  popup.classList.remove('banditos-inline-options');
  document.body.classList.remove('banditos-inline-cart-open');
  trigger?.setAttribute('aria-expanded','false');
 };
 document.addEventListener('click', event => {
  const opener = event.target.closest('[data-open-edit-cart]');
  if (!opener?.closest('.banditos-cart-v2')) return;
  popup = document.querySelector('#halo-edit-cart-popup');
  const row = opener.closest('.cart-item');
  if (!popup || !row) return;
  if (!home) { home = document.createComment('cart option editor home'); popup.before(home); }
  trigger?.setAttribute('aria-expanded','false');
  trigger = opener;
  trigger.setAttribute('aria-controls',popup.id);
  trigger.setAttribute('aria-expanded','true');
  popup.style.setProperty('--inline-cart-font',getComputedStyle(row.querySelector('.cart-item-name') || row).fontFamily);
  popup.classList.add('banditos-inline-options');
  document.body.classList.add('banditos-inline-cart-open');
  row.append(popup);
  contentObserver.disconnect();
  contentObserver.observe(popup,{childList:true,subtree:true});
  relabel();
 }, true);
 new MutationObserver(() => {
  const open = document.body.classList.contains('edit-cart-show');
  if (popup && wasOpen && !open) restore();
  wasOpen = open;
 }).observe(document.body,{attributes:true,attributeFilter:['class']});
 document.addEventListener('keydown',event => {
  if (event.key === 'Escape' && document.body.classList.contains('banditos-inline-cart-open')) {
   document.body.classList.remove('edit-cart-show'); restore(); trigger?.focus({preventScroll:true});
  }
 });
})();